export default function calculateCalendarDefaults(
  startDate?: string | null | Date,
  endDate?: string | null | Date
) {
  // 🔥 DEFAULT: Last 7 days (today inclusive)
  if (!startDate || !endDate) {
    const to = new Date();
    to.setHours(0, 0, 0, 0);

    const from = new Date(to);
    from.setDate(to.getDate() - 6); // last 7 days inclusive

    return {
      dateRange: { from, to },
      quickDays: 7,
    };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const diffInDays =
    Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;

  const quickDays = [7, 15, 30].includes(diffInDays) ? diffInDays : null;

  return {
    dateRange: { from: start, to: end },
    quickDays,
  };
}

export const getLast7DaysRange = () => {
  const to = new Date();
  to.setHours(23, 59, 59, 999);

  const from = new Date(to);
  from.setDate(from.getDate() - 6);
  from.setHours(0, 0, 0, 0);

  return { from, to };
};
